// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"35cd8c61","769":"af9a2ae2"}[chunkId] + ".chunk.css";
};